import React from 'react'
import { useSelector } from 'react-redux'
import { selectDropdownOptions } from '../../redux/dropdownSlice'

const OverrideTag = ({ value, sourceCodeKeyId }) => {
  const dropdownOptions = useSelector(selectDropdownOptions);
  const sourceCodeKey = dropdownOptions.filter((o) => o.id === sourceCodeKeyId)[0]?.code_key;
  let tagName = null;
  if (sourceCodeKey === 'override_source_bk') {
    tagName = 'Bk'
  } else if (sourceCodeKey === 'override_source_dmc') {
    tagName = 'DMC'
  } else if (sourceCodeKey === 'override_source_poa') {
    tagName = 'PoA'
  }

  return (
    <>
      { value }
      {tagName && (<span className="tag ml-1 lox-no-border is-warning special-tag lox-banner-orange">{tagName}</span>)}
    </>
  )
}

export default OverrideTag;
